<template>
  <div>

    <DataTable :value="misc && misc.misc"
               editMode="row" dataKey="id"
               v-model:editingRows="editingRows"
               @row-edit-save="onRowEditSaveMisc"
               responsiveLayout="scroll"
               :loading="loadingTable"
               class="p-datatable-gridlines p-datatable-striped p-datatable-sm editable-cells-table">

      <Column field="tlista" header="Descripción" style="text-align: left;">
        <template #body="{data}">
          <div v-if="data.tlista !== 'Número de Agencias'">{{ data.tlista }}</div>
          <div v-if="data.tlista === 'Número de Agencias'"><strong>{{ data.tlista }}</strong></div>
        </template>
      </Column>
      <Column field="code" header="Valor" style="text-align: center;">
        <template #body="{data}">
          <div v-if="data.tlista !== 'Número de Agencias'">{{ data.code }}</div>
          <div v-if="data.tlista === 'Número de Agencias'"><strong>{{ data.code }}</strong></div>
        </template>
      </Column>
    </DataTable>

  </div>

<!--  <div class="flex justify-content-end">-->
<!--    <Button icon="pi pi-print" class="p-button-raised" :onClick="print"/>-->
<!--  </div>-->

</template>

<script>
import generalMixin from "@/mixins/generalMixin";
import DistributorService from "@/service/backend/DistributorService";

export default {
  name: "Tab5",
  mixins: [generalMixin],
  created() {
    this.distributorService = new DistributorService;
  },
  props: {
    distributor: Object,
  },
  data() {
    return {
      misc: null,
      loadingTable: false,
      editingRows: [],
    }
  },
  async mounted() {

    await this.getData();
  },
  methods: {
    async getData() {
      this.loadingTable = true;
      this.misc = await this.distributorService.getDistributorMiscellaneous({
        id_comercializador: this.distributor.id_comercializador,
        id_distribuidor: this.distributor.id_distribuidor,
        id_banca: this.distributor.id_banca,
        id_psxcmxbanxdis: this.distributor.id_psxcmxbanxdis,
      });
      this.loadingTable = false;
    },
    onRowEditSaveMisc(event) {
      this.bDirty = true;
      let {newData, index} = event;
      this.misc.loteria[index] = newData;
    },
  }

}
</script>

<style scoped lang="scss">
.content {
  width: 100%;
}
.input-text {
  margin: 30px 0 30px 0;
}
.address {
  border: solid 1px lightgray;
  border-radius: 5px;
  margin-top: 5px;
  padding: 15px;
}
.address-label {
  //top: -0.75rem;
  margin-left: 12px;
  font-size: 12px;
  color: gray;
}
.container {
  display: flex;
  /*padding: 10px;*/
  border: solid 1px var(--surface-300);
  margin: 35px 0 15px 0;
  .title {
    margin-right: 10px;
    background-color: var(--primary-color2);
    color: white;
    padding: 10px 10px 10px 15px;
    min-width: 140px;
    font-weight: bold;
  }
  .content {
    padding: 10px 0 0 0;
    min-width: 70px;
    text-align: center;
    font-weight: bold;
  }
}
.table {
  display: block;
}
.row {
  display: block;
}
.cell {
  display: inline-block;
}
.p-button-raised {
  margin-top: 10px;
}
</style>